/*
 * COPYRIGHT MOTOROLA SOLUTIONS, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Component, OnInit, TemplateRef } from '@angular/core';
import { KeycloakService } from '../core/services/keycloak-service';
import { EnvironmentService } from '../core/services/environment.service';
import { VestaKeycloakTokenParsed } from '../user/model/vesta-keycloak-token-parsed';
import { Role } from '../configuration/model/layout-settings';
import { take } from 'rxjs/operators';
import {
    HeaderComponentModule,
    HeaderLeftPluginAreaComponentModule,
    HeaderRightPluginAreaComponentModule,
    ModalModule,
    ModalService,
    MsiModalRef
} from '@msi/cobalt';
import { SkipperService } from '../core/services/skipper.service';
import { HeaderLoginService } from '@msi/commandcentral-user-authentication';
import { IconModule } from '@msi/cobalt/icon';
import { DropdownItemModule, DropdownModule } from '@msi/cobalt/dropdown';
import { SessionManagerComponentModule } from '@msi/commandcentral-common-header';
import { CommonModule } from '@angular/common';
import { CustomDropdownTriggerDirective } from '../core/directives/custom-dropdown-trigger.directive';

@Component({
    selector: 'msi-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    imports: [
        CommonModule,
        HeaderComponentModule,
        HeaderLeftPluginAreaComponentModule,
        HeaderRightPluginAreaComponentModule,
        SessionManagerComponentModule,
        DropdownItemModule,
        DropdownModule,
        IconModule,
        ModalModule,
        CustomDropdownTriggerDirective
    ]
})
export class UnauthorizedComponent implements OnInit {
    public appName: string;
    public filteredRoles: Role[] = [];
    private msiModalRef: MsiModalRef;
    currentRole: string;

    constructor(
        public env: EnvironmentService,
        public keycloakService: KeycloakService,
        private modalService: ModalService,
        private skipperService: SkipperService,
        private headerLoginService: HeaderLoginService
    ) {
        this.appName = env.environment.APP_NAME || 'VESTA NXT';
    }

    ngOnInit() {
        if (this.keycloakService.keycloak.authenticated) {
            const token = this.keycloakService.keycloak.tokenParsed as VestaKeycloakTokenParsed;
            this.currentRole = token?.preferred_role;
            const roles$ = this.skipperService.fetchUserSelectableRoles();
            roles$.pipe(take(1)).subscribe((roles) => {
                this.filteredRoles = roles.filter((role) => role.roleName !== this.currentRole);
            });
        } else {
            this.redirectToHome();
        }
    }

    public changeRole(roleName: string) {
        const token = this.keycloakService.keycloak.tokenParsed as VestaKeycloakTokenParsed;
        this.skipperService.updateCurrentRole(roleName, token.sub).subscribe(() => {
            this.redirectToHome();
        });
    }

    public redirectToHome() {
        window.location.replace('/');
    }

    public signOut(tpl: TemplateRef<any>) {
        this.msiModalRef = this.modalService.open(tpl, {
            hasBackdrop: true,
            disableClose: true,
            minWidth: '25vw'
        });
    }

    public cancel() {
        this.msiModalRef.close();
    }

    public confirm() {
        this.headerLoginService.logout();
    }
}
